import { NgModule, ModuleWithProviders } from '@angular/core';

import { FilterPipe } from './filter';

@NgModule({
    declarations: [FilterPipe],
    exports: [FilterPipe],
})
export class FilterModule {}
